import mixpanel, { Dict } from "mixpanel-browser";

const env_check = import.meta.env.MODE === "production";

const isMixpanelEnabled = env_check && navigator.onLine;

if (isMixpanelEnabled) {
  mixpanel.init(import.meta.env.VITE_MIX_PANEL_TOKEN as string, {
    debug: true,
    persistence: "localStorage",
    track_pageview: true,
  });
}

const actions = {
  identify: (id: string) => {
    if (isMixpanelEnabled) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (isMixpanelEnabled) mixpanel.alias(id);
  },
  track: (name: string, props?: Dict) => {
    if (isMixpanelEnabled)
      mixpanel.track(name, { ...props, current_page_title: document.title });
  },
  people: {
    set: (prop: Dict) => {
      if (isMixpanelEnabled) mixpanel.people.set(prop);
    },
  },
};

export const Mixpanel = actions;
